import React from "react";
import { Layout, Typography, Button } from "antd";
import { Link } from "react-router-dom";

import headerImage from "../Assets/headerIcon.png";

const { Title } = Typography;
const { Header } = Layout;

const CustomHeader = ({ logout, componentName }) => {
  return (
    <Header
      style={{
        background: "#1f2228",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
      }}
    >
      <Title
        level={3}
        style={{ paddingTop: "1%", textIndent: 70 }}
        className="header"
      >
        <img src={headerImage} alt="headerIcon" style={{ height: 25 }} />
      </Title>
      <div>
        {componentName === "Dashboard" && (
          <Button
            style={{
              color: "white",
              background: "#ff0b53",
              borderColor: "#ff0b53",
              borderRadius: 5,
              textTransform: "uppercase",
              marginRight: 10,
            }}
          >
            <Link
              to="/add-latest-article"
              style={{
                // background: "#ff0b53",
                borderColor: "#ff0b53",
                borderRadius: 5,
                textTransform: "uppercase",
              }}
            >
              Add Latest Article
            </Link>
          </Button>
        )}
        {componentName !== "Dashboard" && (
          <Button
            style={{
              color: "white",
              background: "#ff0b53",
              borderColor: "#ff0b53",
              borderRadius: 5,
              textTransform: "uppercase",
              marginRight: 10,
            }}
          >
            <Link to="/dashboard">Dashboard</Link>
          </Button>
        )}
        <Button
          style={{
            color: "white",
            background: "#ff0b53",
            borderColor: "#ff0b53",
            borderRadius: 5,
            textTransform: "uppercase",
            marginRight: 10,
          }}
        >
          <Link to="/app-config">Add App Config</Link>
        </Button>

        <Button
          onClick={logout}
          style={{
            color: "white",
            background: "#ff0b53",
            borderColor: "#ff0b53",
            borderRadius: 5,
            textTransform: "uppercase",
          }}
        >
          Logout
        </Button>
      </div>
    </Header>
  );
};

export default CustomHeader;
